import React from 'react';
import PropTypes from 'prop-types';
import Layout from '../layouts/Layout';
import Header from '../modules/Header';
import Footer from '../modules/Footer';
import EmptySpace from '../modules/EmptySpace';
import EmailSignature from './EmailSignature';
import { url } from '../../../config';
import { PRIMARY_COLOR, GRAY_BG_COLOR } from '../../../constants';

//Style
import { body, buttonStyle, fontWeightBold } from '../../../helpers/getEmailStyles';

class CompletedReservationHost extends React.Component {

  static propTypes = {
    content: PropTypes.shape({
      reservationId: PropTypes.number.isRequired,
      guestName: PropTypes.string.isRequired,
      guestProfilePic: PropTypes.string.isRequired,
    }).isRequired
  };

  render() {
    const { content: { reservationId, logo, siteName, hostName } } = this.props;
    const { content: { guestName, guestProfilePic } } = this.props;
    let messageURL = url + '/review/write/' + reservationId;
    let imageURL;
    if (guestProfilePic) {
      imageURL = url + '/images/avatar/medium_' + guestProfilePic;
    }

    return (
      <Layout>
        <Header color={PRIMARY_COLOR} backgroundColor={GRAY_BG_COLOR} logo={logo} siteName={siteName} />
        <div style={body}>
          <div style={fontWeightBold}>
            Bonjour {hostName},
          </div>
          <EmptySpace height={20} />
          <div>
            {guestName} a effectué son départ — c'est le moment idéal pour laisser un avis !
          </div>
          <EmptySpace height={20} />
          <div>
            Faites-lui savoir ce que vous avez apprécié et comment il peut s'améliorer. Vos commentaires l'aident à améliorer son expérience pour les prochains séjours.
          </div>
          <EmptySpace height={30} />
          <div>
            <a href={messageURL} style={buttonStyle}>Laisser un avis</a>
          </div>
          <EmptySpace height={20} />
          <EmailSignature siteName={siteName} />
        </div>
        <EmptySpace height={40} />
        <Footer siteName={siteName} />
        <EmptySpace height={20} />
      </Layout>
    );
  }

}

export default CompletedReservationHost;



